import { FC, useContext } from "react";
import GenericModalV2 from "../../../shared/GenericModal/GenericModal";
import CustomTextInput from "../../../shared/CustomInput/CustomTextInput";
import { useAppSelector } from "../../../store";
import { AuthContext } from "../../../providers/authProvider";
import { useSimpleForm } from "../../../hooks/useSimpleForm";
import { DirectorForm } from "./DirectorForm/DirectorForm";
import { IDirector } from "../../../models/director";
import { UserForm } from "./UserForm/UserForm";

export const EditProfileModal: FC<{ isOpen: boolean; onClose: () => void }> = ({
  isOpen,
  onClose,
}) => {
  const selectedEntity = useAppSelector((st) => st.me.selectedEntity);
  const { isAdmin, isAthlete, isCoach, isDirector } = useContext(AuthContext);
  const { form, handleChange } = useSimpleForm(
    isDirector
      ? {
          name: (selectedEntity as any).name,
          email: (selectedEntity as any).email,
          firstName: selectedEntity?.firstName,
          lastName: selectedEntity?.lastName,
          phone: (selectedEntity as any)?.phone,
        }
      : {}
  );

  const renderForm = () => {
    switch (true) {
      case isDirector:
        return (
          <DirectorForm
            onClose={onClose}
            form={form as any as IDirector}
            handleChange={handleChange}
          />
        );
      default:
        return (
          <UserForm
            onClose={onClose}
            form={form as any as IDirector}
            handleChange={handleChange}
          />
        );
    }
  };

  return (
    <GenericModalV2
      title="Modifica profilo"
      isOpen={isOpen}
      onClose={onClose}
      size={"lg"}
    >
      <div className="row g-3">{renderForm()}</div>
    </GenericModalV2>
  );
};
